"use client"
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Person } from '@mui/icons-material';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import TtkList from './TtkList';
const WeddingDjTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp; <TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area Of Services :</b>&nbsp; <TtkList data={data?.areaOfWork} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price :</b>&nbsp;<span>{data?.startingPrice}</span></p>
                        </div>
                       

                    </div>
                    <div className='row '>
                        {/* <div className='col-md-4'>
                            <p> <Person sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>No Of Employee :</b>&nbsp;<span>{data?.noOfEmployee}</span></p>
                        </div> */}
                         <div className='col-md-4'>
                            <p ><MusicNoteIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Music Genre You Specialize In ?:</b>&nbsp;<TtkList data={data?.favouriteMusic} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travel Preference :</b>&nbsp;<TtkList data={data?.TravelPreference} /></p>
                        </div>
                    </div>
                </div>
            </div>

        </>


    )
}

export default WeddingDjTTK